module.exports = __webpack_public_path__ + "img/logo.a38b65a7.png";